
interface HeroProps {
  onShowForm: () => void;
}

export default function Hero({ onShowForm }: HeroProps) {
  return (
    <section 
      className="relative bg-gradient-to-br from-gray-900 via-gray-800 to-gray-700 text-white overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/041810f8115af26a1e8a2feb59307752.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-4xl lg:text-6xl font-bold leading-tight">
                その作業、毎日いくら
                <span className="text-yellow-400">奪っていますか？</span>
              </h1>
              <p className="text-xl lg:text-2xl text-gray-200 font-medium">
                micBox ─ インサート交換を自動化し、<br />
                <span className="text-yellow-400">"止まらない段取り"</span>へ。
              </p>
            </div>

            <div className="bg-red-600/20 border border-red-400 rounded-lg p-6 backdrop-blur-sm">
              <p className="text-lg font-semibold text-red-200">
                1回のポーキュパインカッタのチップ交換で40分消費 → 1日15回 → 年間1,000万円級の利益が消える事も‼
              </p>
            </div>

            <p className="text-lg text-gray-200">
              micBoxなら、自動反転・自動トルク・履歴ログで、停止と不良を同時に削減。
            </p>

            <div className="bg-yellow-500/20 border border-yellow-400 rounded-lg p-4 backdrop-blur-sm">
              <p className="text-sm text-yellow-200">
                ※フェイスミルカッターなどの1段のみのカッターにも対応致しますが、1本当たりのチップ数が少ない場合、費用対効果が出にくい場合がございます。また、カッターの種類が多い場合につきましても、効果が出ずらい事がございます。
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={onShowForm}
                className="bg-yellow-500 hover:bg-yellow-600 text-gray-900 px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                60分オンライン見学を予約
              </button>
              <button 
                onClick={onShowForm}
                className="bg-white/10 hover:bg-white/20 text-white border border-yellow-400 px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                御社数字でROIを即表示
              </button>
              <button 
                onClick={onShowForm}
                className="bg-white/10 hover:bg-white/20 text-white border border-yellow-400 px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer backdrop-blur-sm"
              >
                資料を先行請求
              </button>
            </div>

            <div className="bg-yellow-500/20 border border-yellow-400 rounded-lg p-4 backdrop-blur-sm">
              <p className="text-sm text-yellow-200">
                <strong>標準サポート：</strong>平日8:00–17:00。
              </p>
            </div>
          </div>

          <div className="lg:flex justify-end hidden">
            <div className="relative">
              <img 
                src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/63bb24bfc2da116066c69eb755d5e35e.jfif"
                alt="micBox自動インサート交換システム"
                className="rounded-lg shadow-2xl max-w-md w-full object-cover"
              />
              <div className="absolute -bottom-8 -right-4 bg-yellow-400 text-gray-900 p-4 rounded-lg shadow-lg">
                <p className="font-bold text-lg">年間1,000万円</p>
                <p className="text-sm">利益改善効果</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
